import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Report } from '../../report';
import { GateAdminCashSalesReportService } from '../../services/gate-services/gate-admin-cash-sales-report.service';
import { MerchantListService } from '../../services/gate-services/merchant-list.service';
import { ProviderListService } from '../../services/gate-services/provider-list.service';
import moment from 'moment';

@Component({
  selector: 'app-gate-cash-sales',
  templateUrl: './gate-cash-sales.component.html',
  styleUrls: ['./gate-cash-sales.component.scss'],
})
export class GateCashSalesComponent implements OnInit {
  displayTableColumns: { [key: string]: string } = {
    transactionRefNum: 'Reference',
    voucher: 'Voucher',
    cashType: 'Type',
    providerName: 'Provider',
    originalAmount: 'Amount',
    status: 'Status',
    buyerEmail: 'Buyer Email',
    buyerMobile: 'Buyer Mobile',
    buyerNationalId: 'National Id',
    merchantName: 'Merchant Name',
    createStr: 'Created At',
    updateStr: 'Updated Date',
  };
  properties = [
    'transactionRefNum',
    'voucher',
    'cashType',
    'providerName',
    'originalAmount',
    'status',
    'buyerEmail',
    'buyerMobile',
    'buyerNationalId',
    'merchantName',
    'createStr',
    'updateStr',
  ];
  private allKey = { key: 'All', value: null };
  selectFilters = [
    {
      filterDisplayName: 'Types',
      filterFieldName: 'cashType',
      filterOptions: [
        this.allKey,
        { value: 'cash_in', key: 'Cash In' },
        { value: 'cash_out', key: 'Cash Out' },
      ],
      selectedValue: null,
    },
    {
      filterFieldName: 'status',
      filterDisplayName: 'Status',
      filterOptions: [
        this.allKey,
        { key: 'REDEEMED', value: 'REDEEMED' },
        { key: 'EXPIRED', value: 'EXPIRED' },
        { key: 'PENDING', value: 'PENDING' },
      ],
      defaultValue: null,
    },
    {
      filterFieldName: 'merchantId',
      filterDisplayName: 'Merchants',
      filterOptions: [this.allKey],
      defaultValue: null,
    },
    {
      filterFieldName: 'providerId',
      filterDisplayName: 'Providers',
      filterOptions: [this.allKey],
      defaultValue: null,
    },
  ];
  loading = false;
  gateCashSalesData: any[] = [];
  merchants: any[] = [];
  providers: any[] = [];
  actions = [];
  currentMerchant = null;
  totalNumberOfRecords: number = 0;
  requestBody: Report = {};
  itemsPerPage: number = 10;
  loadingFillterData = false;

  constructor(
    public adminCashSalesReport: GateAdminCashSalesReportService,
    private cdr: ChangeDetectorRef,
    private merchantListService: MerchantListService,
    private providerListService: ProviderListService,
  ) {}

  async ngOnInit() {
    this.adminCashSalesReport.activateLoader();
    await this.getMerchants();
    await this.getProviders();
    this.loadingFillterData = true;
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10,
    };
    this.updateTable();
  }
  mapRecordsToFilterOptions(Records: { id: string; name: string }[]) {
    return Records.map((rec) => {
      return { key: rec.name, value: rec.id };
    });
  }
  async getMerchants() {
    this.merchants = await this.merchantListService.getMerchantList();
    const arr = this.mapRecordsToFilterOptions(this.merchants);
    arr.unshift(this.allKey);
    this.selectFilters[2].filterOptions = arr;
  }
  async getProviders() {
    this.providers = await this.providerListService.getProviders();
    const arr = this.mapRecordsToFilterOptions(this.providers);
    arr.unshift(this.allKey);
    this.selectFilters[3].filterOptions = arr;
  }

  async updateTable() {
    this.adminCashSalesReport.activateLoader();
    this.adminCashSalesReport.loader().subscribe((val) => (this.loading = val));
    if (
      this.requestBody['filterOptions'] &&
      this.requestBody['filterOptions']['createdAt']
    ) {
      // @ts-ignore
      const { startDate, endDate } =
        this.requestBody['filterOptions']['createdAt'];
      this.requestBody.filterOptions.createdAt.from =
        moment(startDate).format('YYYY-MM-DD') + ' 00:00:00';
      this.requestBody.filterOptions.createdAt.to =
        moment(endDate).format('YYYY-MM-DD') + ' 23:59:59';
    }
    if (this.requestBody['filterOptions'] && this.currentMerchant) {
      this.requestBody['filterOptions'] = {
        ...this.requestBody['filterOptions'],
        merchantId: this.currentMerchant.merchantId,
      };
    }
    this.adminCashSalesReport.setParams(this.requestBody);
    const responseData = await this.adminCashSalesReport.make();
    this.totalNumberOfRecords = responseData.totalNumberOfRows;
    this.gateCashSalesData = responseData.result;
    this.cdr.detectChanges();
  }

  getCurrentPage(event: any) {
    if (event && Object.keys(event).length) {
      console.log('filter should not be null');
      this.requestBody.filterOptions = event;
    } else {
      console.log('filter should be null');
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10,
    };
    this.updateTable();
  }
  async paginate(event: any) {
    this.requestBody.paginationOptions = {
      start: event.pageIndex * event.pageSize,
      limit: event.pageSize,
    };
    this.updateTable();
  }
  async searchChange(event: any) {
    if (event) {
      this.requestBody.searchOptions = {
        searchKey: event,
      };
    } else {
      this.requestBody.searchOptions = undefined;
    }
    await this.updateTable();
  }
  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction,
      };
    }
    await this.updateTable();
  }
}
